export enum PlatbaStav {
  WAITING = "K zaplacení",
  FAILURE = "Chyba při placení",
  SUCCESS = "Zaplaceno",
  CANCELED= "Odvoláno",
  OVERDUE = "Po splatnosti"
}
